import {
  ApplyOnStatus,
  RegularBenefitVariant,
} from '../../../../../../../typings'

export const EMPTY_NOMINAL_LOYALTY = {
  type: RegularBenefitVariant.NominalLoyalty,
  value: undefined,
  status: ApplyOnStatus.Invoiced,
}
